import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { SwitchButton } from 'app/common/layout/split/SwitchButton'
import { ButtonMedium, media, ResponsiveContainer } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import type { IntlShape } from 'react-intl'
import { FormattedMessage, injectIntl } from 'react-intl'
import { SignupBlock } from 'app/common/layout/split-screen/SignupBlock'
import background_kingdom from 'shared/assets/images/background_kingdom_with_fire.jpg'
import { SignupForm } from 'app/common/forms/signup'
import { SigninForm } from 'app/signin/form'
import { H6 } from 'app/common/typography'

const { yellow } = colors

type Props = {
    activeLeft: boolean,
    className?: string,
    fromUrl: string,
    onLeftFocus?: () => void,
    onRightFocus?: () => void,
    fromEcommerce?: boolean,
    intl: IntlShape
}

type State = {
    toggleTab: boolean
}

class SigninSignupComponent extends Component<Props, State> {
    constructor(props: Props) {
        super()
        this.state = {
            toggleTab: props.activeLeft
        }
    }

    leftFocus = () => {
        const { onLeftFocus } = this.props
        onLeftFocus && onLeftFocus()
        this.setState({ toggleTab: true })
    }

    rightFocus = () => {
        const { onRightFocus } = this.props
        onRightFocus && onRightFocus()
        this.setState({ toggleTab: false })
    }

    render() {
        const { className, fromEcommerce, fromUrl } = this.props
        const { toggleTab } = this.state

        return (
            <StyledFragment>
                <SwitchContainer>
                    <SwitchButton
                        labelKey="app.signup.tab.label"
                        active={toggleTab}
                        handleClick={this.leftFocus}
                    />
                    <SwitchButton
                        labelKey="app.signin.tab.label"
                        active={!toggleTab}
                        handleClick={this.rightFocus}
                    />
                </SwitchContainer>
                <StyledContainer className={className}>
                    {toggleTab ? (
                        <Fragment>
                            <Block noBackground={true}>
                                <SignupForm fromUrl={fromUrl} />
                            </Block>
                            <Block
                                noBackground={true}
                                fromEcommerce={fromEcommerce}>
                                <Inline>
                                    <FormattedMessage id="signup.login.label">
                                        {(text: string) => <H6>{text}</H6>}
                                    </FormattedMessage>
                                    <StyledButtonMedium
                                        background={yellow}
                                        onClick={this.rightFocus}>
                                        <FormattedMessage id="signup.login.button" />
                                    </StyledButtonMedium>
                                </Inline>
                            </Block>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Block noBackground={true}>
                                <SigninForm
                                    fromUrl={fromUrl}
                                    redirectTo={fromUrl}
                                    fromEcommerce
                                />
                            </Block>
                            <Block noBackground={false} noPadding={true}>
                                <SignupBlock onClick={this.leftFocus} />
                            </Block>
                        </Fragment>
                    )}
                </StyledContainer>
            </StyledFragment>
        )
    }
}

const StyledFragment = styled.div``
const SwitchContainer = styled.div`
    display: flex;
    ${media.medium`
        display: none;
    `};
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

const Block = styled.div`
    ${props =>
        props.noPadding
            ? 'background-color: transparent;'
            : props.noBackground
            ? 'background-color: white;'
            : `
                background-image: url(${background_kingdom});
                background-repeat: no-repeat;
                background-size: cover;
    `};
    border-radius: 10px;
    padding: ${props => (!props.noPadding ? '30px' : 0)};
    margin-top: ${props => (props.noPadding ? '30px' : 0)};
    width: 100%;
    height: ${props => (props.noPadding ? 'auto' : '100%')};
    ${props => props.fromEcommerce && `display:none;`};
    ${media.medium`
    padding: ${props => (!props.noPadding ? '40px' : 0)};
    width: ${props =>
        !props.noPadding ? 'calc(43% - 90px)' : 'calc(57% - 0px)'};
    margin-top: 0;
        display: block;
    `};
    ${media.large`
    padding: ${props => (!props.noPadding ? '40px' : 0)};
        width: ${props =>
            !props.noPadding ? 'calc(50% - 90px)' : 'calc(50% - 0px)'};
        margin-top: 0;
    `};
`

const StyledContainer = styled(ResponsiveContainer)`
    position: relative;
    margin-top: 10px;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    max-width: 1280px;
    justify-content: space-between;
    ${media.medium`
        margin-top: 30px;
    `};
`

const StyledButtonMedium = styled(ButtonMedium)`
    align-self: center;
    border: none;
    border-radius: 10px;
    margin-top: 20px;
    width: 100%;
`

const Inline = styled.div`
    display: block;
    ${media.medium`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `};
`

const SigninSignup = injectIntl(SigninSignupComponent)

export { SigninSignup }
